<div class="calendar-wrapper">
  <div class="calendar-header">
    <div class="header-buttons">
      <button class="btn-nav" (click)="previous()">‹</button>
      <button class="btn-today" (click)="today()">Hoy</button>
      <button class="btn-nav" (click)="next()">›</button>
    </div>

    <div class="calendar-title">{{ viewTitle | titlecase }}</div>

    <div class="view-switch">
      <button [class.active]="view === CalendarView.Month" (click)="view = CalendarView.Month">Mes</button>
      <button [class.active]="view === CalendarView.Week" (click)="view = CalendarView.Week">Semana</button>
      <button [class.active]="view === CalendarView.Day" (click)="view = CalendarView.Day">Día</button>
    </div>
  </div>


  <div [ngSwitch]="view">
    <!-- 🌕 VISTA MES -->
    <mwl-calendar-month-view *ngSwitchCase="CalendarView.Month" [viewDate]="viewDate" [events]="events"
      [cellTemplate]="customMonthCellTemplate" (dayClicked)="onDayClicked($event)" (eventClicked)="onEventClicked($event)">
    </mwl-calendar-month-view>

    <!-- 📅 VISTA SEMANA -->
    <mwl-calendar-week-view *ngSwitchCase="CalendarView.Week" [viewDate]="viewDate" [events]="events" [dayStartHour]="0"
      [snapDraggedEvents]="true" (eventTimesChanged)="onEventTimesChanged($event)" [dayEndHour]="24"
      [eventTemplate]="weekEventTemplate" (eventClicked)="onEventClicked($event)" (hourSegmentClicked)="onHourClicked($event)">
    </mwl-calendar-week-view>

    <!-- 🕐 VISTA DÍA -->
    <mwl-calendar-week-view *ngSwitchCase="CalendarView.Day" [viewDate]="viewDate" [daysInWeek]="1" [events]="events"
      [snapDraggedEvents]="true" (eventTimesChanged)="onEventTimesChanged($event)" [locale]="'es'" [dayStartHour]="0"
      [dayEndHour]="24" [eventTemplate]="customDayEventTemplate" (eventClicked)="onEventClicked($event)"
  (hourSegmentClicked)="onHourClicked($event)" >
    </mwl-calendar-week-view>
  </div>
</div>

<ng-template #customMonthCellTemplate let-day="day">
  <div class="cal-cell-top">
    <span class="cal-day-number">{{ day.date | date:'d' }}</span>
  </div>

  <div class="cal-events">
    <div *ngFor="let event of day.events; trackBy: trackByIndex" class="custom-event" [style.borderLeft]="'4px solid ' + event.color?.primary"  (click)="onEventClicked({ event: event })">
      <div class="contact">{{ event.meta?.contactName }}</div>
      <div class="title">{{ event.title }}</div>
    </div>
  </div>
</ng-template>


<ng-template #weekEventTemplate let-weekEvent="weekEvent">
  <div class="custom-event"  (click)="onEventClicked({ event: weekEvent.event })">
    <div class="contact">{{ weekEvent.event.meta?.contactName }}</div>
    <div class="title">{{ weekEvent.event.title }}</div>
  </div>
</ng-template>

<!-- 🕐 DÍA -->
<ng-template #customDayEventTemplate let-weekEvent="weekEvent">
  <div class="custom-event" [style.borderLeft]="'4px solid ' + weekEvent.event.color?.primary"  (click)="onEventClicked({ event: weekEvent.event })">
    <div class="contact">{{ weekEvent.event.meta?.contactName }}</div>
    <div class="title">{{ weekEvent.event.title }}</div>
  </div>
</ng-template>

